export const SET_PRINT_STYLE = "SET_PRINT_STYLE";
export const SET_PRINT_ATTRS = "SET_PRINT_ATTRS";
